<template>
  <v-dialog
    v-model="isDialog"
    max-width="900"
    light
  >
    <v-card v-if="isDialog">
      <!--            <div class="safeScroll">-->
      <div class="absX" @click.passive="closeDialog(true)">
        <v-icon x-large class="myGray">mdi-window-close</v-icon>
      </div>
      <div class="spacer-25"></div>
      <v-card-title class="headline text-center d-block">In welchem Gang soll diese Speise serviert werden?
      </v-card-title>

<!--      <v-card-text v-if="text">-->
<!--        <div v-html="text"></div>-->
<!--      </v-card-text>-->

      <div class="spacer-15"></div>
      <v-card-actions class="text-center justify-center flex-wrap">
        <v-btn class="okBtn btn-df text-none mb-4" rounded v-if="gang1"
               @click.native.passive.stop="doGang(1)">Vorspeise
        </v-btn>
        <v-btn class="grayBtn btn-df text-none mb-4" rounded v-if="gang2"
               @click.native.passive.stop="doGang(2)">
          Hauptspeise
        </v-btn>
        <v-btn class="grayBtn btn-df text-none mb-4" rounded v-if="gang3"
               @click.native.passive.stop="doGang(3)">
          Dessert
        </v-btn>
      </v-card-actions>
      <div class="pb-3"></div>
      <!--            </div>-->
    </v-card>
  </v-dialog>
</template>

<script>
import {ebus} from '@/vendor/ebus';

export default {
  props: {
    dialog: Boolean,
    gang1: {
      type: Boolean,
      default: true
    },
    gang2: {
      type: Boolean,
      default: true
    },
    gang3: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      isDialog: false
    }
  },
  watch: {
    dialog(newValue) {
      this.isDialog = newValue;
      console.log('update dialog=' + !!newValue);
      if (newValue) {
        //init
      }
    },
    isDialog(newValue) {
      console.log('update isDialog=' + !!newValue);
      if (!newValue) {
        this.$emit('silentclose');
        // this.ready = false;
        // this.$emit('close');
      }
    }
  },

  methods: {
    closeDialog(explizitClose) {
      this.isDialog = false;
      console.log('question isDialog = false; explizitClose=' + !!explizitClose);
      if (explizitClose) {
        this.$emit('close');//no
      } else {
        this.$emit('silentclose');
      }
    },
    doGang(g) {
      this.closeDialog();
      ebus.$emit('cb-selectedGang', g);
    },
  }
}
</script>

<style lang="scss" scoped>
/*@import '../styles/vuetify-dark';*/
</style>
